var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { parsePhoneNumber } from "react-phone-number-input";
import { get } from "lodash";
import client from "@irati/utils/services/apollo";
import mfaHasFlagQuery from "./queries/mfaHasFlag";
import mfaRequestQuery from "./queries/mfaRequest";
import mfaValidateQuery from "./queries/mfaValidate";
import mfaGetUserQuery from "./queries/mfaGetUser";
import mfaGetSupportedCountriesQuery from "./queries/mfaGetSupportedCountries";
import mfaDeleteUserMutation from "./mutations/mfaDeleteUser";
import mfaSetupMutation from "./mutations/mfaSetup";
import tokens from "./tokens";
import mfa from "../utils/mfa";
var MFA = /** @class */ (function () {
    function MFA() {
    }
    MFA.prototype.hasFlag = function () {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.query({ query: mfaHasFlagQuery, fetchPolicy: "network-only" })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.mfaHasFlag];
                }
            });
        });
    };
    MFA.prototype.request = function () {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.query({ query: mfaRequestQuery, fetchPolicy: "network-only" })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.mfaRequest];
                }
            });
        });
    };
    MFA.prototype.validate = function (code) {
        return __awaiter(this, void 0, Promise, function () {
            var variables, data, _a, success, accessToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        variables = { code: code };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 4, 5]);
                        return [4 /*yield*/, client.query({ query: mfaValidateQuery, variables: variables, fetchPolicy: "network-only" })];
                    case 2:
                        data = (_b.sent()).data;
                        _a = data.mfaValidate, success = _a.success, accessToken = _a.accessToken;
                        return [4 /*yield*/, tokens.set({ accessToken: accessToken })];
                    case 3:
                        _b.sent();
                        mfa.complete();
                        return [2 /*return*/, success];
                    case 4:
                        mfa.show = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MFA.prototype.setup = function (phoneNumber) {
        return __awaiter(this, void 0, Promise, function () {
            var country, variables, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        country = get(parsePhoneNumber(phoneNumber), "country") || "GB";
                        variables = { phoneNumber: phoneNumber, country: country };
                        return [4 /*yield*/, client.mutate({ mutation: mfaSetupMutation, variables: variables, fetchPolicy: "no-cache" })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.mfaSetup];
                }
            });
        });
    };
    MFA.prototype.getUser = function (userId) {
        return __awaiter(this, void 0, Promise, function () {
            var variables, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        variables = { userId: userId };
                        return [4 /*yield*/, client.query({ query: mfaGetUserQuery, variables: variables, fetchPolicy: "network-only" })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.mfaGetUser];
                }
            });
        });
    };
    MFA.prototype.deleteUser = function (userId) {
        return __awaiter(this, void 0, Promise, function () {
            var variables, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        variables = { userId: userId };
                        return [4 /*yield*/, client.mutate({ mutation: mfaDeleteUserMutation, variables: variables, fetchPolicy: "no-cache" })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.mfaDeleteUser];
                }
            });
        });
    };
    MFA.prototype.supportedCountries = function () {
        return __awaiter(this, void 0, Promise, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.query({ query: mfaGetSupportedCountriesQuery })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.mfaSupportedCountries];
                }
            });
        });
    };
    return MFA;
}());
export default new MFA();
